import "../../utils/cgu.css";
import { useEffect, useState } from "react";
import mammoth from "mammoth";

const MentionsLegales = () => {
    const [content, setContent] = useState("");
    
      useEffect(() => {
        fetch("/docs/Mentions légales-PAXITY.docx")
          .then(res => res.arrayBuffer())
          .then(arrayBuffer => {
            mammoth.convertToHtml({ arrayBuffer })
              .then(result => {
                setContent(result.value);
              })
              .catch(err => console.error("Erreur conversion DOCX:", err));
          });
      }, []);
    
      return (
        <div>
          <div
            className="document-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      );
      
};

export default MentionsLegales;
